/* eslint-disable no-constant-condition */
import classNames from 'classnames';
import styled from 'styled-components';
import { Popover } from 'antd';
import { ToolTipOfTopPeople } from 'Types/BuyerGroupsPageTypes';
import {
  maxMobile, maxTablet,
  minExtraLargeScreen,
  minStandardScreen,
  minWidthApp,
  primaryFont,
  retina, white, wMedium,
} from 'Utils/utilsStyle';
import InfoIcon from '../assets/icons/InforIcon';

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  background-color: ${white};
  box-shadow: 0px 0px 16.724px -1.967px rgba(0, 0, 0, 0.04);
  @media all and (min-width: ${minExtraLargeScreen}) {
  }
  @media all and (${retina}) {
  }
  @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
    border-radius: 7px;
  }
  @media all and (max-width: ${maxTablet}) {
  }
  @media all and (max-width: ${maxMobile}){
  }
  .heading,
  .count{
    color: #3F4B50;
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 18px;
    font-style: normal;
    line-height: 18px;
    letter-spacing: -0.369px;
    margin: 0;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    overflow: hidden;
    @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
      font-size: 14px;
      line-height: 16px;
      letter-spacing: -0.323px;
    }
  }
  .rowHeadingWrapper,
  .columnHeadingWrapper{
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
  }
  .columnHeadingWrapper{
    .count{
      margin-left: 4px;
      @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
        margin-left: 2px;
      }
      span{
        display: inline-flex;
        margin-top: 2px;
      }
    }
    .f-right{
      position: relative;
      cursor: pointer;
      svg {
        height: 16px;
        width: 16px;
        display: flex;
        margin-left: 6px;
        @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
          height: 12px;
          width: 12px;
        }
      }
    }
  }
  .rowHeadingBox{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    .rowHeadingWrapper{
      writing-mode: vertical-lr;
      text-orientation: mixed;
      transform: rotate(180deg);
      flex: unset;
      .count{
        margin-top: 6px;
        @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
          margin-top: 4px;
        }
        span{
          display: inline-flex;
          margin-right: 2px;
        }
      }
    }
    .f-right{
      position: relative;
      cursor: pointer;
      svg {
        height: 16px;
        width: 16px;
        display: flex;
        margin-bottom: 6px;
        @media all and (max-width: ${minStandardScreen}), (max-width: ${minWidthApp}) {
          height: 12px;
          width: 12px;
        }
      }
    }
    .hover-general-popover{
      max-width: 250px;
      .ant-popover-inner-content{
        padding: 20px 16px !important;
      }
      .label-popover{
        margin-bottom: 0 !important;
      }
    }
  }
`;

type Props = {
  className?: string,
  heading: string,
  count: number,
  isRowHeading?: boolean,
  toolTip?: ToolTipOfTopPeople,
  toolTipTextOnly?: string,
  loading?: boolean,
} & typeof defaultProps;

const defaultProps = {
  className: '',
  isRowHeading: false,
  toolTip: {},
  toolTipTextOnly: '',
  loading: false,
};
const rowTooltip = function tooltip(toolTipTextOnly: string) {
  return (
    <div>
      {
        toolTipTextOnly?.length ? (
          <div className="label-popover">
            {toolTipTextOnly}
          </div>
        ) : null
      }
    </div>
  );
};
const tooltip = function tooltip(toolTipProps: ToolTipOfTopPeople) {
  const { description, dataList } = toolTipProps;
  return (
    <div>
      {
        description?.length ? (
          <div className="label-popover">
            {description}
          </div>
        ) : 'Description Here'
      }
      {
        dataList?.length ? (
          <ul>
            {
              dataList.map((point) => (
                <li key={point}>
                  {point}
                </li>
              ))
            }
          </ul>
        ) : 'List Here'
      }
    </div>
  );
};

const GridHeadingBox = function GridHeadingBox(props: Props) {
  const {
    className, toolTip, toolTipTextOnly, heading, count, isRowHeading, loading,
  } = props;
  return (
    <Wrapper className={classNames(className, 'headingWrapper')}>
      {isRowHeading
        ? (
          <div className="rowHeadingBox">
            {!loading && toolTipTextOnly && (
              <Popover
                placement="leftTop"
                content={rowTooltip(toolTipTextOnly)}
                overlayClassName="hover-general-popover"
                getPopupContainer={(e: HTMLElement) => e}
                zIndex={1}
                arrow={false}
              >
                <span className="f-right"><InfoIcon /></span>
              </Popover>
            )}
            <div className="rowHeadingWrapper">
              <p className="heading">{heading}</p>
              <span className="count">
                &#40;
                <span>{count}</span>
                &#41;
              </span>
            </div>
          </div>
        )
        : (
          <div className="columnHeadingWrapper">
            <p className="heading">{heading}</p>
            <span className="count">
              &#40;
              <span>{count}</span>
              &#41;
            </span>
            {!loading && (
              <Popover
                placement="bottomRight"
                content={tooltip(toolTip)}
                overlayClassName="hover-general-popover"
                getPopupContainer={(e: HTMLElement) => e}
                arrow={false}
              >
                <span className="f-right"><InfoIcon /></span>
              </Popover>
            )}
          </div>
        )}
    </Wrapper>
  );
};

GridHeadingBox.defaultProps = defaultProps;
export default GridHeadingBox;
